import { render, staticRenderFns } from "./TikTokPost.vue?vue&type=template&id=bb6efff4&scoped=true"
import script from "./TikTokPost.vue?vue&type=script&lang=ts"
export * from "./TikTokPost.vue?vue&type=script&lang=ts"
import style0 from "./TikTokPost.vue?vue&type=style&index=0&id=bb6efff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6efff4",
  null
  
)

export default component.exports